// Centralized URL + query utilities (replaces scattered toUrl concatenations)

export function buildQuery(params: Record<string, unknown> | undefined | null): string {
  if (!params) return '';
  const entries = Object.entries(params).filter(([_, v]) => v !== undefined && v !== null);
  if (entries.length === 0) return '';
  const usp = new URLSearchParams();
  for (const [k, v] of entries) {
    if (Array.isArray(v)) {
      v.forEach(item => usp.append(k, String(item)));
    } else {
      usp.append(k, String(v));
    }
  }
  const query = usp.toString();
  return query ? `?${query}` : '';
}

export function joinUrl(base: string, ...parts: string[]): string {
  return [base.replace(/\/$/, ''), ...parts.map(p => p.replace(/^\//, ''))].join('/');
}
